import { Alert, Button, Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import AxiosInstance from 'src/shared/services/axios/interceptor';

type StripeConnectModalProps = {
  stripeConnectModal: boolean;
  setStripeConnectModal: (kivraModal: boolean) => void;
  stripeAccount?: string;
  invoiceGroupId: number;
};

export const StripeConnectModal = (props: StripeConnectModalProps) => {
  const { stripeConnectModal, setStripeConnectModal, stripeAccount, invoiceGroupId } = props;
  const { t } = useTranslation();
  const isMounted = useIsMounted();

  const stripeActivation = async () => {
    const result = await AxiosInstance.get(`Stripe/CreateAccount?invoiceGroupId=${invoiceGroupId}`);
    if (isMounted()) window.location = result.data;
  };

  return (
    <GenericDialog
      maxWidth='sm'
      disableBackdropClosing
      dialogActions={
        <>
          <Button variant='outlined' color='primary' disableElevation onClick={() => setStripeConnectModal(false)}>
            {t('common:button.cancel')}
          </Button>
          <Button autoFocus variant='contained' color='primary' disabled={!!stripeAccount} disableElevation onClick={() => stripeActivation()}>
            {t('invoice:adminInvoiceGroupDetailPage.connect')}
          </Button>
        </>
      }
      open={stripeConnectModal}
      dialogTitle={t('invoice:adminInvoiceGroupDetailPage.connectStripe')}
      dialogContent={
        <Grid container spacing={3}>
          {stripeAccount === null ||
            (stripeAccount === undefined && (
              <Grid item xs={12} p={0} mb={2}>
                <Alert
                  icon={false}
                  severity='info'
                  sx={{
                    '& .MuiAlert-message': { width: '100% !important' },
                    fontWeight: 500,
                    m: -2,
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  {t('invoice:adminInvoiceGroupDetailPage.connectStripeDescription')}
                </Alert>
              </Grid>
            ))}

          {stripeAccount && (
            <Grid item xs={12}>
              <TextField
                label={t('invoice:adminInvoiceGroupDetailPage.stripeAccountNumberLabel')}
                disabled
                value={stripeAccount}
                fullWidth
                size='small'
              />
            </Grid>
          )}
        </Grid>
      }
      onClose={() => setStripeConnectModal(false)}
      onSave={() => {
        setStripeConnectModal(false);
      }}
    />
  );
};
